import map from 'lodash/map';
import max from 'lodash/max';
import maxBy from 'lodash/maxBy';
import sum from 'lodash/sum';

export const selectTotalScoreNumber = (games, scoreKey) => (
  sum(map(games, game => game[scoreKey]))
);

export const selectBestScoreNumber = (games, scoreKey) => (
  max(map(games, game => game[scoreKey]))
);

export const selectBestScoreFraction = (games, scoreKey) => (
  maxBy(
    map(games, game => game[scoreKey]),
    fraction => parseInt(fraction.split('/')[0], 10),
  )
);
